import api from './axios';

const BACKEND_ORIGIN = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api')
  .replace(/\/api$/, '');

export const resolveBannerUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_ORIGIN}${url}`;
};

export const bannersAPI = {
  /** GET /api/banners — active banners only, public */
  get: () => api.get('/banners'),
};
